import React from 'react';
import clsx from 'clsx';
import { Colors } from '@common/tokens';
import { Text } from '@common/components';

export const Card = ({
  title,
  className,
  children,
  dataTestid,
}: React.PropsWithChildren<{
  title?: string;
  className?: string;
  dataTestid?: string;
}>) => {
  return (
    <>
      <div data-testid={dataTestid} className={clsx('wk-card', className)}>
        {title && (
          <header className="wk-card-header">
            <Text bold size="lg">
              {title}
            </Text>
          </header>
        )}
        <main className="wk-card-body">{children}</main>
      </div>
      <style jsx>{`
        .wk-card {
          border-radius: 4px;
          background-color: ${Colors.white};
          border: 1px solid ${Colors.steel};
          box-shadow: 0px 1px 3px rgba(18, 81, 91, 0.1);
          width: 100%;
        }
        .wk-card-header {
          padding: 16px;
          background-color: ${Colors.elmHyperlight};
          width: 100%;
        }
        .wk-card-body {
          width: 100%;
          padding: 16px;
        }
      `}</style>
    </>
  );
};
